// Generated by GitHub Copilot
import configuration from "./index";
import { authFetch } from "../utils/authFetch";

export const VersionHistoryAPI = {
  listVersions: async function (problemID) {
    const endpoint = configuration.apiBase + `/problem/${problemID}/versions`;

    try {
      const response = await authFetch(endpoint, {
        credentials: "include", // Include session cookies
      });

      if (!response.ok) {
        // US2097708: read the error body so a responder that supplies operator-facing
        // copy (see restoreVersion below) can surface it. Only `message` is read,
        // deliberately never `error`: handlers that answer through renderError put raw
        // err.Error() in `error`, internal detail that must not reach the UI. Do NOT
        // add a `|| errorData.error` fallback.
        //
        // The .catch is load-bearing, not defensive: this endpoint's not-found path
        // ends in a bare 404 with no body at all, and a proxy 502 returns HTML —
        // either makes response.json() reject, turning a handled failure into a
        // rejected promise out of a function whose contract is to RESOLVE with
        // { success: false }. The status stays in the fallback so "it failed" is still
        // actionable when the body tells us nothing.
        const errorData = await response.json().catch(() => ({}));
        return {
          success: false,
          error: errorData.message || `HTTP error! status: ${response.status}`,
        };
      }

      const data = await response.json();
      return {
        success: true,
        versions: data.versions || [],
      };
    } catch (error) {
      console.error("Error fetching version history:", error);
      return {
        success: false,
        error: error.message,
      };
    }
  },

  getVersion: async function (problemID, versionID) {
    const endpoint =
      configuration.apiBase + `/problem/${problemID}/version/${versionID}`;

    try {
      const response = await authFetch(endpoint, {
        credentials: "include", // Include session cookies
      });

      if (!response.ok) {
        // US2097708: `message` only, never `error`, and the .catch is required — see
        // listVersions above for both.
        const errorData = await response.json().catch(() => ({}));
        return {
          success: false,
          error: errorData.message || `HTTP error! status: ${response.status}`,
        };
      }

      const data = await response.json();
      return {
        success: true,
        content: data,
      };
    } catch (error) {
      console.error("Error fetching version:", error);
      return {
        success: false,
        error: error.message,
      };
    }
  },

  restoreVersion: async function (problemID, versionID) {
    const endpoint =
      configuration.apiBase + `/problem/${problemID}/restore/${versionID}`;

    try {
      const response = await authFetch(endpoint, {
        method: "POST",
        credentials: "include", // Include session cookies
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        // US2097708: a restore that would resurrect a promoted-away PRBT is refused
        // with a 409 whose body carries operator-facing copy naming the record and
        // telling them to reopen the permanent one (built in
        // handlePromotedRecordWriteRejection). Discarding the body reduced that to a
        // bare status code in Viewer's handleRestoreVersion. `message` only, and the
        // .catch is required — see listVersions above for both.
        const errorData = await response.json().catch(() => ({}));
        return {
          success: false,
          error: errorData.message || `HTTP error! status: ${response.status}`,
        };
      }

      const data = await response.json();
      return {
        success: true,
        data: data,
      };
    } catch (error) {
      console.error("Error restoring version:", error);
      return {
        success: false,
        error: error.message,
      };
    }
  },
};
